import { Box, Flex, Text } from '@chakra-ui/layout';
import { Avatar, Icon } from '@chakra-ui/react';
import Avatar1 from 'assets/img/avatars/avatar1.png';
import CardMy from 'components/CardMy';
import DatePicker from 'components/DatePicker';
import UserDropdown from 'components/UserDropdown';
import { addDays, addMonths } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { HiLightningBolt } from 'react-icons/hi';
import { IoArrowDownOutline, IoArrowUpOutline } from 'react-icons/io5';

const data = [
    {
        title: 'Dials',
        value: 780,
    },
    {
        title: 'Pickups',
        value: 78,
        rate: {
            value: 12,
            type: '+',
        },
    },
    {
        title: 'Convos',
        value: 65,
        rate: {
            value: 83,
            type: '+',
        },
    },
    {
        title: 'Offers',
        value: 30,
        rate: {
            value: 45,
            type: '-',
        },
    },
    {
        title: 'Sets',
        value: 25,
        rate: {
            value: 83,
            type: '+',
        },
    },
    {
        title: 'Texts Sent',
        value: 243,
        rate: {
            value: 83,
            type: '+',
        },
    },
    {
        title: 'Triages',
        value: 18,
    },
    {
        title: 'DQs',
        value: 4,
        rate: {
            value: 83,
            type: '+',
        },
    },
];

const users = [
    'Spencer Handley',
    'Emily Parker',
    'David Miller',
    'Sarah Thompson',
    'James Anderson',
    'Amanda Maxwell',
    'Marc Ferguson',
    'Elmer Curtis',
    'Kevin Tate',
    'Edith Mathis',
    'Norman Parks',
    'Douglas Goodwin',
];

const options = users.map(user => ({
    label: user,
    value: user,
}));

enum FILTER_VALUES {
    day = 'Day',
    week = 'Week',
    month = 'Month',
    date_range = 'Date range',
}

const UserInfo = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [selectedDates, setSelectedDates] = useState<Date[]>([new Date(), new Date()]);
    const [user, setUser] = useState(options[0]);
    const [filters, setFilters] = useState([
        { label: FILTER_VALUES.day, selected: true, value: [new Date(), new Date()] },
        { label: FILTER_VALUES.week, selected: false, value: [new Date(), addDays(new Date(), 7)] },
        { label: FILTER_VALUES.month, selected: false, value: [new Date(), addMonths(new Date(), 1)] },
        { label: FILTER_VALUES.date_range, selected: false, value: [new Date(), addMonths(new Date(), 1)] },
    ]);

    useEffect(() => {
        const selected = filters.find(item => item.selected);
        setSelectedDates(selected.value);
        if (selected.label === FILTER_VALUES.date_range) {
            ref.current.querySelector('input').click();
        }
    }, [filters]);

    return (
        <CardMy>
            <Flex mb="26px" gap="8px" flexWrap="wrap">
                <UserDropdown
                    sx={{ width: '300px', marginRight: 'auto' }}
                    onChange={setUser}
                    value={user}
                    options={options}
                />
                <Flex flexWrap="wrap" gap="8px">
                    <div ref={ref}>
                        <DatePicker selectedDates={selectedDates} onDateChange={setSelectedDates} />
                    </div>
                    <Flex
                        borderRadius="100px"
                        borderColor="gray.200"
                        borderWidth="1px"
                        height="40px"
                        alignItems="center"
                        padding="4px"
                    >
                        {filters.map(filter => {
                            const handleClick = () => {
                                const changed = filters.map(item => ({
                                    ...item,
                                    selected: item.label === filter.label ? true : false,
                                }));
                                setFilters(changed);
                            };
                            const color = filter.selected ? 'brand.500' : 'gray.900';
                            const background = filter.selected ? 'brand.50' : 'transparent';
                            return (
                                <Box
                                    key={filter.label}
                                    fontSize="14px"
                                    fontWeight={500}
                                    borderRadius="100px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    as="button"
                                    onClick={handleClick}
                                    height="32px"
                                    background={background}
                                    color={color}
                                    paddingX="12px"
                                >
                                    {filter.label}
                                </Box>
                            );
                        })}
                    </Flex>
                </Flex>
            </Flex>
            <Flex mb="26px" alignItems="center" justifyContent="space-between">
                <Flex alignItems="center" gap="16px">
                    <Avatar src={Avatar1} width="72px" height="72px" />
                    <div>
                        <Text
                            fontSize="24px"
                            fontWeight="700"
                            letterSpacing="-0.48px"
                            color="gray.900"
                            lineHeight={1}
                            mb="8px"
                        >
                            Spencer Handley
                        </Text>
                        <Text color="gray.900" fontWeight={500} display="flex" alignItems="center" gap="4px">
                            <Icon color="inherit" as={HiLightningBolt} width="16px" height="16px" />
                            83%
                            <Text color="gray.500" as="span" fontWeight={500}>
                                Monthly Productivity
                            </Text>
                        </Text>
                    </div>
                </Flex>
                <Box
                    background="linear-gradient(94deg, #5B6880 0%, #4A5568 100%)"
                    borderRadius="8px"
                    width="300px"
                    padding="16px"
                >
                    <Flex display="flex" alignItems="center" justifyContent="space-between" color="gray.300">
                        <Text fontSize="sm" fontWeight="500" display="flex" alignItems="center">
                            <Icon color="inherit" as={HiLightningBolt} width="16px" height="16px" marginRight="4px" />
                            RGAT
                        </Text>

                        <Text fontSize="12px" fontWeight="500">
                            <Text color="white" as="span" fontSize="sm" fontWeight="600">
                                +23% &nbsp;
                            </Text>
                            since last month
                        </Text>
                    </Flex>
                    <Text
                        fontSize="24px"
                        fontWeight="700"
                        letterSpacing="-0.48px"
                        color="white"
                        mt="8px"
                        lineHeight="1"
                    >
                        23.4 hours
                    </Text>
                </Box>
            </Flex>

            {/* ======================================== */}

            <Flex gap="8px">
                {data.map((item, index) => {
                    const color = item?.rate?.type === '+' ? 'green.500' : 'red.500';
                    const icon = item?.rate?.type === '+' ? IoArrowUpOutline : IoArrowDownOutline;

                    return (
                        <Flex
                            key={index}
                            bgColor="gray.50"
                            padding="16px"
                            flexDirection="column"
                            flex="1 0 0"
                            borderRadius="8px"
                        >
                            <Text
                                color="gray.500"
                                fontSize="sm"
                                fontWeight="500"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                lineHeight={1}
                            >
                                {item.title}
                                {!!item.rate && <Icon color={color} as={icon} width="16px" height="16px" />}
                            </Text>
                            <Text
                                fontSize="24px"
                                fontWeight="700"
                                letterSpacing="-0.48px"
                                marginTop="20px"
                                mb="16px"
                                color="gray.900"
                                lineHeight={1}
                            >
                                {item.value}
                            </Text>
                            {!!item.rate && (
                                <Text fontSize="sm" fontWeight="600" mt="auto" color={color} lineHeight={1}>
                                    {item.rate.value}%
                                    <Text as="span" color="gray.500" fontSize="12px" fontWeight="500">
                                        &nbsp;rate
                                    </Text>
                                </Text>
                            )}
                        </Flex>
                    );
                })}
            </Flex>
        </CardMy>
    );
};

export default UserInfo;
